import { monthNames } from '../components';

export function getNextTimeGiftWillProcess(frequency: string): string {
  const items = frequency.split(', ').map(item => item.trim());
  const months = items.filter(item => !item.startsWith('day'));
  const days = items
    .filter(item => item.startsWith('day'))
    .map(item => parseInt(item.replace('day', ''), 10));

  const today = new Date();
  const currentMonthIndex = today.getMonth();
  const currentDay = today.getDate();

  let nextMonthIndex = months.length === 1 ? 0 : currentMonthIndex;
  let nextDay = days.find(day => day > currentDay) || days[0];
  let nextYear = today.getFullYear();

  if (!nextDay || nextDay <= currentDay) {
    if (months.length > 1) {
      nextMonthIndex = (currentMonthIndex + 1) % months.length;
      if (nextMonthIndex === 0) {
        nextYear += 1;
      }
    } else {
      nextMonthIndex = 0;
      if (findIndexOfMonth(months[0]) <= currentMonthIndex) {
        nextYear += 1;
      }
    }

    nextDay = days[0];
  }

  const nextMonth = months[nextMonthIndex];
  const nextRunDate = new Date(`${nextMonth} ${nextDay}, ${nextYear}`);

  const formattedDate = `${String(nextRunDate.getMonth() + 1).padStart(2, '0')}/${String(nextDay).padStart(2, '0')}/${nextRunDate.getFullYear()}`;
  return formattedDate;
}

function findIndexOfMonth(month: string): number {
  return monthNames
    .map(m => m.toLocaleLowerCase())
    .indexOf(month.toLowerCase());
}
